import Tippy from '@tippy.js/react';
import cn from 'classnames';
import React from 'react';
import Typography from '~components/typography';

interface ITippyBaseProps {
  content: string | React.ReactElement;
  icon: React.ReactElement;
  tippyClassName?: string;
  tippyIconClassName?: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  appendTo?: 'parent';
  tippyIconStyle?: React.CSSProperties;
}

const TippyBase: React.FC<ITippyBaseProps & React.HTMLAttributes<HTMLDivElement>> = ({
  content,
  className,
  tippyClassName,
  tippyIconClassName,
  appendTo,
  icon,
  placement = 'top',
  style,
  tippyIconStyle,
}) => {
  return (
    <div className={className} style={{ ...style }}>
      <Tippy
        content={
          typeof content === 'string' ? (
            <Typography variant="meta" color="var(--color-white)">
              {content}
            </Typography>
          ) : (
            content
          )
        }
        appendTo={appendTo || document.body}
        animation="scale"
        placement={placement}
        className={cn('tippy-base', tippyClassName)}
      >
        <div style={{ ...tippyIconStyle }} className={tippyIconClassName}>
          {icon}
        </div>
      </Tippy>
      <style jsx>{`
        :global(.tippy-base[data-placement^='top'] > .tippy-arrow) {
          border-top-color: var(--color-purple_6);
        }
        :global(.tippy-base) {
          background-color: var(--color-purple_6);
        }
        :global(.tippy-base .tippy-content) {
          padding: 12px 20px;
        }
      `}</style>
    </div>
  );
};

export default TippyBase;
